export const aciMinibar = {
    iconName: 'minibar',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.963 3.13a.383.383 0 00-.383.383V19.47c0 .212.171.383.383.383H18.12a.383.383 0 00.382-.383V3.513a.383.383 0 00-.382-.382H5.963zm-1.389.383c0-.766.622-1.388 1.389-1.388H18.12c.766 0 1.388.622 1.388 1.388V19.47c0 .767-.622 1.389-1.388 1.389H5.963a1.388 1.388 0 01-1.389-1.389V3.513z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M7.61 19.852c.278 0 .503.225.503.502v1.267a.503.503 0 01-1.006 0v-1.267c0-.277.226-.502.503-.502zM16.474 19.852c.277 0 .502.225.502.502v1.267a.503.503 0 11-1.005 0v-1.267c0-.277.225-.502.503-.502zM7.61 8.457c.278 0 .503.225.503.503v3.799a.503.503 0 01-1.006 0v-3.8c0-.277.226-.502.503-.502z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
